export const LOCAL_STORE_PREFIX = 'truelink-microsite'
export const STATE_KEY = 'state'
export const MOBILE_BREAK = 1024
export const CLOSE_FRAME_ANIMATION_DURATION = 250
export const SCROLL_TO_USE_CASES_DURATION = 250
